import { useMutation, useQueryClient } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { EmailSettingsUpdate, SendTestEmail } from "../../models/emailSettings/EmailSettings";
import { emailSettingsQueryKeys } from "./queryKeys";


export function useEmailSettingsMutations(agencyId: string) {
  const queryClient = useQueryClient();
  const { post, put } = useApiHelper();
  const { saveHandlers } = useDefaultCRUDHandlers("Email Settings");

  const update = useMutation(
    (data: EmailSettingsUpdate) => put(`/marketing/${agencyId}/settings`, data),
    {
      ...saveHandlers,
      onSuccess: (_) => {
        queryClient.invalidateQueries(emailSettingsQueryKeys.all(agencyId));
        saveHandlers.onSuccess?.();
      },
    }
  );

  const sendTest = useMutation((req: SendTestEmail) =>
      post(
        `/marketing/${agencyId}/newsletter/send-test`,
        { email: req.email }
      )
    );
    
  return {
    update,
    sendTest,
  };
}
